import { action } from "@ember/object"
import { cancel, later } from "@ember/runloop"
import type { EmberRunTimer } from "@ember/runloop/types"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import config from "cc-frontend/config/environment"

export default class OfflineNotice extends Component {
  @service("ember-store") store
  @service socket
  @service router

  _pollTimer: EmberRunTimer | null = null

  constructor(owner, args) {
    super(owner, args)
    // This causes our tests to stall forever.
    if (config.environment !== "test") {
      this._pollTimer = later(this, this.checkOfflineStatus, 3300)

      // check for window.addEventListener
      if (window && window.addEventListener) {
        window.addEventListener("offline", (e) => {
          this.computerIsOffline = true
        })

        window.addEventListener("online", (e) => {
          this.computerIsOffline = false
        })
      }
    }
  }

  @tracked serverIsOffline = false
  @tracked computerIsOffline = false

  get isOffline() {
    return this.serverIsOffline || this.computerIsOffline
  }

  isOnlineChecks = [true, true, true]

  // Only check offline every 3 seconds so short stuff like
  // switching over the server doesn't trigger the notice
  checkOfflineStatus() {
    if (this.isDestroyed) return
    // Remove the oldest check
    this.isOnlineChecks.shift()
    // Push in a new check
    this.isOnlineChecks.push(this.socket.isOnline)
    // Check if we've been online during the last 3 checks
    if (this.isOnlineChecks.includes(true)) {
      this.serverIsOffline = false
    } else {
      // this means we haven't been online for the last 3 checks so let's show the notice
      this.serverIsOffline = true
    }
    this._pollTimer = later(this, this.checkOfflineStatus, 1000)
  }

  willDestroy() {
    if (this._pollTimer) cancel(this._pollTimer)
    super.willDestroy()
  }

  @action
  reloadPage() {
    window.location.reload()
  }
}
